var exports = {
  "kL": "x804f0401--452521--container",
  "wx": "x804f0401--452521--header",
  "Qs": "x804f0401--452521--content",
};

module.exports = exports;
